import { IEnvironment } from "../app/app.model";

export const environment: IEnvironment = {
    appId: 1,
    appName: "insizon",
    IsProd: true,
    baseUrl: "https://dev-api.insizon.com/api",
    adoreBaseUrl: "https://dev-api.adoretheballoon.com/api",
    PopTheBallonDatingAppId: "690fad57f61d5fd8dc487cd2",
    PwaFrontendBaseUrl: "#",
    SupportEmail: "support@insizon.com",
    BusinessName: "Insizon, LLC",
    BusinessAddress: {
        Street: "10228 E Northwest Hwy #1183",
        City: "Dallas",
        State: "Texas",
        ZipCode: "75238",
        Country: "United States"
    }
};
